import {OracleMethods} from './oracle';
import { EngagementDiscountManagerMethods as ManagerMethods } from './manager';

export const EngagementMethods = {
  ...OracleMethods,
  ...ManagerMethods,
};

export default EngagementMethods;